import { inject, injectable } from 'inversify';

import { ConfigOptionDataService } from 'src/app/general/config-option/form/config-option-form.data';
import { IdentityService } from 'src/core/services/identity.service';
import { HttpService } from 'src/core/services/http.service';
import * as FileSaver from "file-saver";

@injectable()
export class ConfigOptionsService {
	dataService: ConfigOptionDataService;

	configuration: ConfigurationOptions;

	@inject(HttpService)
	httpService: HttpService;

	constructor(@inject(IdentityService) private identityService: IdentityService) {
		this.dataService = ConfigOptionDataService.make();
		this.configuration = {};
	}

	async getAutoConnetProductConfig() {
		if (this.configuration == null || this.configuration.autoConnetProduct == null) {
			let autoConnetProductConfig = await this.dataService.find(x => x.key == 'AutoConnectProducts');
			this.configuration.autoConnetProduct = autoConnetProductConfig ?JSON.parse( autoConnetProductConfig.value) : { "products": [{ "id": "06cf0a10-55c9-42f4-9880-b138d02e219d", "productType": 1, "categories": [] }, { "id": "6de92833-9e13-43d9-9fbd-037122fb2d76", "productType": 5, "categories": [] }, { "id": "de65774c-3713-4933-a4e8-caf727336cf3", "productType": 4, "categories": [] }, { "id": "d3c921d4-8c81-4d18-a7eb-148a6acafdec", "productType": 0, "categories": [38] }] };
		}
		return this.configuration.autoConnetProduct;
	}
	async getUseAllotmentBeforeBookings() {
		if (this.configuration == null || this.configuration.useAllotmentBeforeBookings == null) {
			let config = await this.dataService.find(x => x.key == 'useAllotmentBeforeBookings');
			this.configuration.useAllotmentBeforeBookings = config ? config.value.toLowerCase()=="true"?true:false : false;
		}

		return this.configuration.useAllotmentBeforeBookings;
	}
	async getLogo() {
		if (this.configuration == null || this.configuration.logo == null) {
			let logoConfig = await this.dataService.find(x => x.key == 'Logo');
			this.configuration.logo = logoConfig ? logoConfig.value : 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAVCAYAAAAnzezqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAGYktHRAD/AP8A/6C9p5MAAAHZSURBVEhLxZW7jsJADEU9QTwaGhqE+ADEo0dIUPLVNPwDCAQtIOh5v5czi0PE7mYmxYorWTOx79g3licxvV7vLh9E8Fw/Bm8B9/vdmgu+PIWXgNvtZtfL5RKbnBgcoGdccArQN+p2u9JsNmW/3/8qAh8xOHD1nAuBEv+y8/ksrVbLkguFgrTb7VBE1PARgwM4w9l33rsFtCrOgiCQfr8v2+3WJqZAp9OR3W4n1+vVGnt8WhwuZzj7W86omfF47OwTSo/Ho9RqNclkMtbH82QysftKpSLZbNbuT6eTjEYj+2yMsb44mMFg4D2ytBQRWmy9Xts1n8/bFVEUT6fT9tkHZjgcegugE4ioVquSy+We3m8cDgd5dNMW93lzRaIPEYkp8BD99LyAL2lxkEiAdqDRaDw9L+DTqU8C5zWMms6Atp8Z0DnAR0xF+JqXAK4Liev1ejiAm81GptOpNfaAGJwkIsx8Pnf2DAHlctnea8DArVarcNopWCqVQnHwF4tFyI+DswN824vF4o/iqVQq5LBfLpc2BuByRv8dceaUSDIKgmjx6LSzx0dMRbD36YCZzWZeX0JAa0n611WDpxzgcyXdEh/QRHHFAbEkxYGXAEBCn6S+PIW3gP+ByBfxJS5nmEXtPwAAAABJRU5ErkJggg==';
		}

		return this.configuration.logo;
	}

	async getHeaderImage() {
		if (this.configuration == null || this.configuration.header == null) {
			let headerConfig = await this.dataService.find(x => x.key == 'HeaderDoc');
			this.configuration.header = headerConfig ? headerConfig.value : '21wEnTU+mcD2w0Lfo1Gv4rtcSWsQJQTNa6gio05AOkV/Er9w3Y13Ddo5wGtjJ19402S71HUeN0vbKILLJdRSES5MHSdJPSVrOqdrll/vLXxDxWs/U0UT1c8u6k/Ogx9hTtZxYwoeYqdhDblof3E75d9n2F0Zvf6iTb4cI7j6fMs=';
		}

		return this.configuration.header;
	}

	async getFooterImages() {
		if (this.configuration == null || this.configuration.footer == null) {
			let footerConfig = await this.dataService.find(x => x.key == 'FooterDoc');
			this.configuration.footer = footerConfig ? footerConfig.value : '21wEnTU+mcD2w0Lfo1Gv4rtcSWsQJQTNa6gio05AOkV/Er9w3Y13Ddo5wGtjJ19402S71HUeN0vbKILLJdRSES5MHSdJPSVrOqdrll/vLXxDxWs/U0UT1c8u6k/Ogx9hTtZxYwoeYqdhDblof3E75d9n2F0Zvf6iTb4cI7j6fMs=';
		}

		return this.configuration.footer;
	}

	async reboot() {
		await this.httpService.get("api/v1/reboot");
	}

	async downloadLogs() {
		await this.httpService.get(`api/v1/download_logs`, { responseType: "blob" })
			.then(res => {
				const blob = res.data;
				FileSaver.saveAs(blob,"logs.txt");
			});
	}
}



// WEBPACK FOOTER //
// ./src/core/services/config-options.service.ts